import clx from 'classnames';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Image from 'utils/Image';
import useDeckChangeHero from './hook';

type Props = {
  closeModal: () => void;
  deckId: string;
  faction: string;
};

const DeckChangeHeroModal = ({ closeModal, deckId, faction }: Props) => {
  const { handleSubmit, formMethods, options } = useDeckChangeHero({ deckId, faction, closeModal });
  const { t } = useTranslation();
  const selectedAlterator = formMethods.watch('alterator');

  return (
    <ModalClassicLayout closeModal={closeModal} onSubmit={handleSubmit} title={t('choose-this-alterator')}>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit}>
          {options && (
            <div className="flex gap-2 justify-between overflow-auto">
              {Object.keys(options).map((k) => (
                <button // copied from src/components/template/Decks/create/index.tsx
                  key={k}
                  className={clx(
                    'shrink-0 border-4 rounded-lg overflow-hidden',
                    'transition-colors duration-quick ease-out',
                    selectedAlterator === k
                      ? 'border-primary-500'
                      : 'border-transparent hover:border-primary-100 hover:opacity-85',
                  )}
                  onClick={() => formMethods.setValue('alterator', k)}
                  type="button"
                >
                  <Image alt="" height={200} src={options[k]!.image!} width={300} />
                </button>
              ))}
            </div>
          )}
          <input className="hidden" type="submit" />
        </form>
      </FormProvider>
    </ModalClassicLayout>
  );
};

export default DeckChangeHeroModal;
